// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/custom.scss' // 変更
import BootstrapVue from 'bootstrap-vue'

import VueI18n from 'vue-i18n'

import axios from 'axios'
import moment from 'moment'

import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.use(Vuex)

const data = require('./message.json')

// 言語の設定
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja-jp', // デフォルト言語はjaにしておくが、ブラウザの言語を拾ってきてここに入れる => 言語変更されたら書き換える
  messages: data
})

console.log(i18n)

Vue.use(BootstrapVue)

Vue.config.productionTip = false

const initialState = {
  ticketId: '',
  downloadId: '',
  editId: '',
  language: '',
  opId: '',
  userName: '',
  editProcessId: '',
  editLineId: '',
  editMachineId: '',
  menuList: {},
  machineHold: false,
  operatorHold: false,
  serialHold: false,
  loading: false
}

export const store = new Vuex.Store({
  state: initialState,
  mutations: {
    setLang (state, args) {
      console.log('mutations setLang')
      state.language = args.amount
    },
    setMachineHold (state, args) {
      console.log('mutations setMachineHold')
      state.machineHold = args.amount
    },
    setOperatorHold (state, args) {
      console.log('mutations setOperatorHold')
      state.operatorHold = args.amount
    },
    setSerialHold (state, args) {
      console.log('mutations setSerialHold')
      state.serialHold = args.amount
    }
  },
  actions: {
    setLang (context, arg1) {
      console.log('actions setLang')
      context.commit({
        type: 'setLang',
        amount: arg1
      })
    },
    setMachineHold (context, arg1) {
      console.log('actions setMachineHold')
      context.commit({
        type: 'setMachineHold',
        amount: arg1
      })
    },
    setOperatorHold (context, arg1) {
      console.log('actions setOperatorHold')
      context.commit({
        type: 'setOperatorHold',
        amount: arg1
      })
    },
    setSerialHold (context, arg1) {
      console.log('actions setSerialHold')
      context.commit({
        type: 'setSerialHold',
        amount: arg1
      })
    }
  },
  getters: {
    getLang: state => {
      return state.language
    },
    getMachineHold: state => {
      return state.machineHold
    },
    getOperatorHold: state => {
      return state.operatorHold
    },
    getSerialHold: state => {
      return state.serialHold
    }
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})

const initCookeiStoreState = {
  inputConfirm: false,
  dispProcess1: '',
  dispProcess2: '',
  dispProcess3: ''
}

const cookieStore = new Vuex.Store({
  state: initCookeiStoreState,
  mutations: {
    setInputConfirm (state, args) {
      console.log('mutations setInputConfirm')
      state.inputConfirm = args.amount
    },
    setDispProcess1 (state, args) {
      console.log('mutations setDispProcess1')
      state.dispProcess1 = args.amount
    },
    setDispProcess2 (state, args) {
      console.log('mutations setDispProcess2')
      state.dispProcess2 = args.amount
    },
    setDispProcess3 (state, args) {
      console.log('mutations setDispProcess3')
      state.dispProcess3 = args.amount
    }
  },
  actions: {
    setInputConfirm (context, arg1) {
      console.log('actions setInputConfirm')
      context.commit({
        type: 'setInputConfirm',
        amount: arg1
      })
    },
    setDispProcess1 (context, arg1) {
      console.log('actions setDispProcess1')
      context.commit({
        type: 'setDispProcess1',
        amount: arg1
      })
    },
    setDispProcess2 (context, arg1) {
      console.log('actions setDispProcess2')
      context.commit({
        type: 'setDispProcess2',
        amount: arg1
      })
    },
    setDispProcess3 (context, arg1) {
      console.log('actions setDispProcess3')
      context.commit({
        type: 'setDispProcess3',
        amount: arg1
      })
    }
  },
  getters: {
    getInputConfirm: state => {
      return state.inputConfirm
    },
    getDispProcess1: state => {
      return state.dispProcess1
    },
    getDispProcess2: state => {
      return state.dispProcess2
    },
    getDispProcess3: state => {
      return state.dispProcess3
    }
  },
  plugins: [createPersistedState()]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  router,
  store: {store, cookieStore},
  cookieStore,
  components: { App },
  template: '<App/>',
  created () {
    // created時に初期StateをlocalStorageに保存しておく。
    localStorage.setItem('initialState', JSON.stringify(initialState))
  }
})



// WEBPACK FOOTER //
// ./src/main.js